
import React, { useState, useEffect, ChangeEvent, SyntheticEvent } from 'react';
import Dropdown, { DropdownOption } from '../../components/Dropdown';
import Input, {
  FilterLabeledInputRowWrapper,
} from '../../components/forms/Input';
import { USER_STATUS, USER_ROLE } from '../../constants';
import FormButtonRow from '../components/formButtonRow';

interface ManageUsersFilterProps {
  usernameFilter: string;
  setUsernameFilter: (value: string) => void;
  emailAddressFilter: string;
  setEmailAddressFilter: (value: string) => void;
  statusFilter: string;
  setStatusFilter: (value: string) => void;
  roleFilter: string;
  setRoleFilter: (value: string) => void;
  setClearFlag: (value: boolean) => void;
  onSubmit: () => void;
}

const ManageUsersFilter: React.FC<ManageUsersFilterProps> = ({
  usernameFilter,
  setUsernameFilter,
  emailAddressFilter,
  setEmailAddressFilter,
  statusFilter,
  setStatusFilter,
  roleFilter,
  setRoleFilter,
  setClearFlag,
  onSubmit,
}) => {
  const statusOptions: DropdownOption<string>[] = [
    {
      value: 'Any',
      text: 'Any',
    },
    {
      value: USER_STATUS.ACTIVE,
      text: USER_STATUS.ACTIVE,
    },
    {
      value: USER_STATUS.INACTIVE,
      text: USER_STATUS.INACTIVE,
    },
  ];
  const roleOptions: DropdownOption<string>[] = [
    {
      value: 'Any',
      text: 'Any',
    },
    {
      value: USER_ROLE.ACCOUNT_ADMIN, //'Administrator'
      text: USER_ROLE.ACCOUNT_ADMIN, //'Administrator'
    },
    {
      value: USER_ROLE.AGENT, //'Agent'
      text: USER_ROLE.AGENT, //'Agent'
    },
  ];
  const usernameKeypressHandler = (event: ChangeEvent<HTMLInputElement>) => setUsernameFilter(event.target.value);
  const emailAddressKeypressHandler = (
    event: ChangeEvent<HTMLInputElement>,
  ) => setEmailAddressFilter(event.target.value);
  const statusChangeHandler = (value: string | number | readonly string[] | undefined) => {
    if (value) {
      setStatusFilter(value as string);
    }
  };
  const roleChangeHandler = (value: string | number | readonly string[] | undefined) => {
    if (value) {
      setRoleFilter(value as string);
    }
  };

  const [defaults, setDefaults] = useState({
    usernameFilter: '',
    emailAddressFilter: '',
    statusFilter: '',
    roleFilter: '',
  });

  useEffect(() => {
    setDefaults({
      usernameFilter,
      emailAddressFilter,
      statusFilter,
      roleFilter,
    });
  }, []);

  const clearHandler = () => {
    setUsernameFilter(defaults.usernameFilter);
    setEmailAddressFilter(defaults.emailAddressFilter);
    setStatusFilter(defaults.statusFilter);
    setRoleFilter(defaults.roleFilter);
    setClearFlag(true);
  };

  const usernameId = 'username';
  const emailId = 'emailAddress';
  const statusId = 'status';
  const roleId = 'role';
  return (
    <>
      <FilterLabeledInputRowWrapper elementId={usernameId} label="Username">
        
          <Input
            id={usernameId}
            name={usernameId}
            value={usernameFilter}
            onChange={usernameKeypressHandler}
            autocomplete="off"
          />
        
      </FilterLabeledInputRowWrapper>
      <FilterLabeledInputRowWrapper elementId={emailId} label="Email Address">
        
          <Input
            id={emailId}
            name={emailId}
            value={emailAddressFilter}
            onChange={emailAddressKeypressHandler}
            autocomplete="off"
          />
        
      </FilterLabeledInputRowWrapper>
      <FilterLabeledInputRowWrapper elementId={statusId} label="Status">
        <Dropdown
          id={statusId}
          value={statusFilter}
          options={statusOptions}
          onChange={statusChangeHandler}
        />
      </FilterLabeledInputRowWrapper>
      <FilterLabeledInputRowWrapper elementId={roleId} label="Role">
        <Dropdown
          id={roleId}
          value={roleFilter}
          options={roleOptions}
          onChange={roleChangeHandler}
        />
      </FilterLabeledInputRowWrapper>
      <FormButtonRow onClear={clearHandler} onSubmit={onSubmit} />
    </>
  );
};

export default ManageUsersFilter;
